var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-tabs",
        { staticClass: "mb-1" },
        [
          _c("b-tab", {
            attrs: { title: _vm.$t("cancellation.policies") },
            on: {
              click: function ($event) {
                return _vm.$router.push("/cancellations/policies")
              },
            },
          }),
          _c("b-tab", {
            attrs: { title: _vm.$t("cancellation.product_rules") },
            on: {
              click: function ($event) {
                return _vm.$router.push("/cancellations/product_rules")
              },
            },
          }),
          _c("b-tab", {
            attrs: { title: _vm.$t("cancellation.requests"), active: "" },
          }),
        ],
        1
      ),
      _vm.stats
        ? _c("div", { staticClass: "vx-row mb-2" }, [
            _c(
              "div",
              { staticClass: "vx-col sm:w-1/4 w-full" },
              [
                _c("statistics-card-line", {
                  attrs: {
                    hideChart: "",
                    icon: "ZapIcon",
                    "icon-right": "",
                    statistic: _vm.stats.auto_rate + "%",
                    statisticTitle: _vm.$t("cancellation.stats_auto"),
                    color: "success",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-1/4 w-full" },
              [
                _c("statistics-card-line", {
                  attrs: {
                    hideChart: "",
                    icon: "ClockIcon",
                    "icon-right": "",
                    statistic: _vm.stats.pending_count,
                    statisticTitle: _vm.$t("cancellation.stats_pending"),
                    color: "warning",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-1/4 w-full" },
              [
                _c("statistics-card-line", {
                  attrs: {
                    hideChart: "",
                    icon: "FlagIcon",
                    "icon-right": "",
                    statistic: _vm.stats.contested_count,
                    statisticTitle: _vm.$t("cancellation.stats_contested"),
                    color: "danger",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "vx-col sm:w-1/4 w-full" },
              [
                _c("statistics-card-line", {
                  attrs: {
                    hideChart: "",
                    icon: "RepeatIcon",
                    "icon-right": "",
                    statistic: _vm.stats.reschedule_rate + "%",
                    statisticTitle: _vm.$t("cancellation.stats_reschedule"),
                    color: "primary",
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "flex justify-between items-center flex-wrap mb-1" },
        [
          _c(
            "b-tabs",
            {
              on: { input: _vm.changeTab },
              model: {
                value: _vm.tabIndex,
                callback: function ($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex",
              },
            },
            [
              _c("b-tab", {
                attrs: {
                  title:
                    _vm.$t("cancellation.tab_pending") +
                    (_vm.stats ? " · " + _vm.stats.pending_count : ""),
                },
              }),
              _c("b-tab", {
                attrs: { title: _vm.$t("cancellation.tab_auto") },
              }),
              _c("b-tab", {
                attrs: { title: _vm.$t("cancellation.tab_contested") },
              }),
              _c("b-tab", { attrs: { title: _vm.$t("cancellation.tab_all") } }),
            ],
            1
          ),
          _c(
            "b-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: "cancellation_requests.edit",
                  expression: "'cancellation_requests.edit'",
                },
              ],
              attrs: { variant: "outline-danger" },
              on: {
                click: function ($event) {
                  return _vm.$refs.clubCancelModal.open()
                },
              },
            },
            [
              _c("feather-icon", {
                staticClass: "mr-50",
                attrs: { icon: "XCircleIcon" },
              }),
              _c("span", { staticClass: "align-middle" }, [
                _vm._v(_vm._s(_vm.$t("cancellation.club_cancel"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          hide_actions: true,
          forceFilters: _vm.tabFilters,
          route_name: "cancellation_requests",
          order_column: "created_at",
          direction: "asc",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c(
                  "vs-th",
                  { key: "protocol", attrs: { "sort-key": "protocol" } },
                  [_vm._v(_vm._s(_vm.$t("cancellation.protocol")))]
                ),
                _c(
                  "vs-th",
                  { key: "customer", attrs: { "sort-key": "customer_name" } },
                  [_vm._v(_vm._s(_vm.$t("cancellation.student")))]
                ),
                _c("vs-th", { key: "product" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.product"))),
                ]),
                _c("vs-th", { key: "reason" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.reason"))),
                ]),
                _c("vs-th", { key: "rule" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.applied_rule"))),
                ]),
                _c("vs-th", { key: "remedy" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.proposed_remedy"))),
                ]),
                _c("vs-th", { key: "age" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.open_for"))),
                ]),
                _c("vs-th", { key: "actions" }, [_vm._v("Ações")]),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "protocol", attrs: { width: "9%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.protocol))]),
                    ]),
                    _c("vs-td", { key: "customer", attrs: { width: "13%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.customer_name))]),
                    ]),
                    _c("vs-td", { key: "product", attrs: { width: "14%" } }, [
                      _c("div", [_vm._v(_vm._s(tr.product_label))]),
                    ]),
                    _c("vs-td", { key: "reason", attrs: { width: "12%" } }, [
                      tr.reason === "ME"
                        ? _c(
                            "div",
                            { staticClass: "health-reason-cell" },
                            [
                              _c(
                                "vs-chip",
                                {
                                  staticClass: "text-base",
                                  attrs: { transparent: "", color: "danger" },
                                },
                                [_vm._v("Motivo médico")]
                              ),
                              _c("small", [
                                _vm._v("Dado sensível — visível no detalhe"),
                              ]),
                            ],
                            1
                          )
                        : _c("div", [
                            _vm._v(
                              _vm._s(
                                tr.reason_text ||
                                  _vm.$t("cancellation.reason_." + tr.reason)
                              )
                            ),
                          ]),
                    ]),
                    _c("vs-td", { key: "rule", attrs: { width: "16%" } }, [
                      _c("div", [_vm._v(_vm._s(_vm.ruleLabel(tr)))]),
                    ]),
                    _c("vs-td", { key: "remedy", attrs: { width: "15%" } }, [
                      _c("div", [_vm._v(_vm._s(_vm.remedyLabel(tr)))]),
                    ]),
                    _c(
                      "vs-td",
                      { key: "age", attrs: { width: "8%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            staticClass: "text-base",
                            attrs: {
                              transparent: "",
                              color: _vm.ageColor(tr.created_at),
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.ageLabel(tr.created_at)) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vs-td",
                      { key: "actions", attrs: { width: "13%" } },
                      [
                        tr.status === "PA"
                          ? _c(
                              "div",
                              { staticClass: "flex flex-row gap-2" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: "cancellation_requests.edit",
                                        expression:
                                          "'cancellation_requests.edit'",
                                      },
                                    ],
                                    staticClass: "mr-1",
                                    attrs: { variant: "success", size: "sm" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.approve(tr)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("cancellation.approve")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: "cancellation_requests.edit",
                                        expression:
                                          "'cancellation_requests.edit'",
                                      },
                                    ],
                                    attrs: {
                                      variant: "outline-danger",
                                      size: "sm",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deny(tr)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("cancellation.deny")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : tr.status === "CO" || tr.status === "HA"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value: "cancellation_requests.edit",
                                        expression:
                                          "'cancellation_requests.edit'",
                                      },
                                    ],
                                    attrs: { variant: "primary", size: "sm" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$router.push(
                                          "/cancellations/requests/" +
                                            tr.id +
                                            "/contestation"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("cancellation.respond")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c(
                              "vs-chip",
                              {
                                staticClass: "text-base",
                                attrs: {
                                  transparent: "",
                                  color: _vm.statusColor(tr.status),
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "cancellation.request_status_." +
                                          tr.status
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
      _c("ClubCancelModal", {
        ref: "clubCancelModal",
        on: { executed: _vm.refresh },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }